import { render, staticRenderFns } from "./JoinPlatformScreen.vue?vue&type=template&id=21be385c&scoped=true"
import script from "./JoinPlatformScreen.vue?vue&type=script&lang=js"
export * from "./JoinPlatformScreen.vue?vue&type=script&lang=js"
import style0 from "./JoinPlatformScreen.vue?vue&type=style&index=0&id=21be385c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be385c",
  null
  
)

export default component.exports